module.exports = __webpack_public_path__ + "static/media/hrzz_logo.82eed081.svg";